import script from "./ContainerLogsActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContainerLogsActions.vue?vue&type=script&setup=true&lang=ts"

import "./ContainerLogsActions.vue?vue&type=style&index=0&id=748d228d&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748d228d"]])

export default __exports__